import React, { useState, useEffect } from 'react';
import cc from 'classcat';
import { faCheckCircle, faTimesCircle } from '@fortawesome/pro-solid-svg-icons';
import { Row, Col } from '../../../grid';
import Icon from '../../atoms/icon';
import Button from '../../molecules/button';
import { CardFrame, CardBlock, CardTitle } from '../../organisms/card';
import ContactCard from '../../organisms/contact/card';
import ContactSearch from '../../organisms/contact/search';
import Pagination from '../../organisms/pagination';

import { IContact, useGetContacts } from '../../../libs/contact';
import { IChatThread } from '../../../libs/chat';

interface PrescribeContactProps {
  className?: string;
  isActive: boolean;
  contact?: IContact;
  setContact: (contact: IContact) => void;
  chatThread?: IChatThread;
  interactive?: boolean;
  hideHeader?: boolean;
}

const PAGE_LIMIT = 6;

const PrescribeContact: React.FC<PrescribeContactProps> = ({
  isActive,
  className,
  contact,
  setContact,
  chatThread,
  interactive = true,
  hideHeader = false
}) => {
  const classes = cc([isActive ? null : 'opacity-50', className]);

  const [keyword, setKeyword] = useState<string>('');
  const [page, setPage] = useState(1);
  const { contacts, total } = useGetContacts({
    page: page - 1,
    keyword,
    limit: PAGE_LIMIT
  });
  // Reset the page when keyword changed
  useEffect(() => {
    setPage(1);
  }, [keyword]);

  useEffect(() => {
    if (chatThread?.contact !== null) {
      setContact(chatThread?.contact);
    } else if (chatThread?.contactId === null) {
      setContact(null);
    }
  }, [contacts]);

  return (
    <CardFrame interactive={interactive} className={classes}>
      {!hideHeader && (
        <CardTitle>
          <h2>
            {contact && (
              <Icon className="text-green mr-4" icon={faCheckCircle} />
            )}
            3. Select Contact
          </h2>
        </CardTitle>
      )}
      {isActive &&
        (contact ? (
          <>
            <CardBlock>
              <ContactCard contact={contact} isSelected />
              <Button
                icon={<Icon icon={faTimesCircle} />}
                onClick={() => setContact(null)}
              >
                Select Another Contact
              </Button>
            </CardBlock>
          </>
        ) : (
          <>
            <CardBlock>
              <ContactSearch
                className="mb-4"
                keyword={keyword}
                setKeyword={setKeyword}
                noCreate
              />
              <Row className="mb-4">
                {contacts &&
                  contacts.map((contact) => (
                    <Col key={contact.id} md={8}>
                      <ContactCard
                        contact={contact}
                        isSelected={chatThread?.contact?.id === contact.id}
                        onClick={() => setContact(contact)}
                      />
                    </Col>
                  ))}
                {!contacts || contacts.length === 0 ? (
                  <Col md={8}>No results found.</Col>
                ) : null}
              </Row>
              <Pagination
                page={page}
                total={total}
                limit={PAGE_LIMIT}
                onPageChange={setPage}
              />
            </CardBlock>
          </>
        ))}
    </CardFrame>
  );
};

export default PrescribeContact;
